import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useCalendarData, fmtDate } from "@/hooks/useCalendarData";
import { DayList } from "@/components/app/calendar/CalendarLists";
import { WeeklyGrid, MonthlyGrid } from "@/components/app/calendar/CalendarGrids";

export default function CalendarPage() {
  const { view, setView, anchor, setAnchor, range, jobsByDate, shift, title } = useCalendarData();

  return (
    <div className="space-y-6" data-testid="calendar-page">
      <div className="flex flex-wrap items-center gap-3">
        <Tabs value={view} onValueChange={setView}>
          <TabsList data-testid="calendar-view-toggle">
            <TabsTrigger value="daily" data-testid="calendar-daily-tab">Günlük</TabsTrigger>
            <TabsTrigger value="weekly" data-testid="calendar-weekly-tab">Haftalık</TabsTrigger>
            <TabsTrigger value="monthly" data-testid="calendar-monthly-tab">Aylık</TabsTrigger>
          </TabsList>
        </Tabs>
        <div className="flex items-center gap-2 ml-auto">
          <Button variant="outline" size="icon" onClick={() => shift(-1)} data-testid="prev-btn"><ChevronLeft className="h-4 w-4" /></Button>
          <Button variant="outline" size="sm" onClick={() => setAnchor(new Date())} data-testid="today-btn">Bugün</Button>
          <Button variant="outline" size="icon" onClick={() => shift(1)} data-testid="next-btn"><ChevronRight className="h-4 w-4" /></Button>
        </div>
      </div>

      <h2 className="text-2xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }} data-testid="calendar-title">{title}</h2>

      {view === "daily" && (
        <Card className="p-6 border-slate-200"><DayList jobs={jobsByDate[fmtDate(anchor)] || []} /></Card>
      )}
      {view === "weekly" && <WeeklyGrid days={range.days} jobsByDate={jobsByDate} />}
      {view === "monthly" && <MonthlyGrid days={range.days} anchor={anchor} jobsByDate={jobsByDate} />}
    </div>
  );
}
